export const getSliderImage = (slide, isMobile) =>
  (isMobile && slide.foto_mobile) || slide.foto || "";
